// extracted by mini-css-extract-plugin
export default {"link":"HeaderLink_link__4-WB0","alert":"HeaderLink_alert__opzAv"};